<template>
  <img
    src="@/assets/img/payments/visa.svg"
    alt="mastercard"
    class="h-6 w-9 rounded-sm"
    loading="lazy"
    aria-hidden
  >
</template>
